// extracted by mini-css-extract-plugin
export default {"zoomModal":"i6-z","image":"j6-z","button":"k6-z","isOverlayShown":"l6-z"};